import { Box, HStack, Skeleton, Text, Tooltip, VStack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { Icon, InfoIcon, WarningIcon } from "@src/components/ui-kit/Icon";
import { currency } from "@src/utils/formatters";
import { useStore } from "@src/utils/hooks";
import React, { type PropsWithChildren } from "react";

interface BudgetProps {
  budget: number;
  billable: boolean | undefined;
  isNewerFinalVersionAvailable?: boolean;
  isInternallyApproved?: boolean | null;
  billingPlanIsMissing?: boolean;
  isTimeAndMaterials?: boolean;
  fetching?: boolean;
}

const TooltipLabelWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Box minW="100px" maxW="300px" p="3" fontSize="xs" textAlign="right">
      {children}
    </Box>
  );
};

export const Budget = (props: BudgetProps) => {
  const { workspaceStore } = useStore();

  return (
    <VStack align="end">
      <Skeleton isLoaded={!props.fetching}>
        <HStack>
          {props.isTimeAndMaterials && (
            <Tooltip label={t`Time & Materials`} shouldWrapChildren>
              <Icon name="time-and-materials" color="grey.500" />
            </Tooltip>
          )}
          {props.billable === false && (
            <Tooltip label={t`Non-billable`} shouldWrapChildren>
              <Icon name="non-billable" color="grey.500" />
            </Tooltip>
          )}
          <Text>{currency.formatByWorkspace(props.budget)}</Text>
        </HStack>
      </Skeleton>
      <HStack>
        {workspaceStore.settings?.moduleSettings.budgetovac && (
          <React.Fragment>
            {props.isNewerFinalVersionAvailable === true && (
              <Tooltip
                label={
                  <TooltipLabelWrapper>
                    <Trans>New version of Budget is available</Trans>
                  </TooltipLabelWrapper>
                }
                shouldWrapChildren
              >
                <InfoIcon color="green" />
              </Tooltip>
            )}
            {props.isInternallyApproved === false && (
              <Tooltip
                label={
                  <TooltipLabelWrapper>
                    <Trans>Assigned budget is not internally approved</Trans>
                  </TooltipLabelWrapper>
                }
                shouldWrapChildren
              >
                <WarningIcon />
              </Tooltip>
            )}
          </React.Fragment>
        )}
        {workspaceStore.settings?.moduleSettings.billing_plan &&
          props.billingPlanIsMissing && (
            <Tooltip
              label={
                <TooltipLabelWrapper>
                  <Trans>Invoicing plan is not filled</Trans>
                </TooltipLabelWrapper>
              }
              shouldWrapChildren
            >
              <WarningIcon />
            </Tooltip>
          )}
      </HStack>
    </VStack>
  );
};
